import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import { image_base_url } from "../api/api";

const ProductImageManager = () => {
  const { productId } = useParams();   // ✅ GET FROM URL
  const fileInputRef = useRef(null); 

  const [images, setImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // 👈 navigation hook

  const numericProductId = parseInt(productId); // convert to number

  // 🔹 Load Images
  const loadImages = async () => {
    try {
      const res = await api.get(`/ProductImages/${numericProductId}`);
      setImages(res.data);
    } catch (error) {
      console.error("Error loading images:", error);
    }
  };

  useEffect(() => {
    if (numericProductId) {
      loadImages();
    }
  }, [numericProductId]);

  // 🔹 Upload Image
  const handleUpload = async () => {
    if (!numericProductId) {
      alert("Invalid product ID");
      return;
    }

    if (!selectedFile) {
      alert("Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append("files", selectedFile);

    try {
      setLoading(true);

      await api.post(
        `/ProductImages/upload/${numericProductId}`,
        formData
      );

      alert("Image uploaded successfully");
      setSelectedFile(null);

      // ✅ Clear input visually
      if (fileInputRef.current) {
         fileInputRef.current.value = "";
      }

      loadImages();
    } catch (error) {
      console.error("Upload error:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Delete Image
  const handleDelete = async (imageId) => {
    if (!window.confirm("Are you sure to delete this image?")) return;

    try {
      await api.delete(`/ProductImages/${imageId}`);
      loadImages();
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  // 🔹 Set Main Image
  const handleSetMain = async (imageId) => {
    try {
      await api.put(`/ProductImages/set-main/${imageId}`);
      loadImages();
    } catch (error) {
      console.error("Set main image error:", error);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Product Images (Product ID: {numericProductId})</h5>
          <button className="btn btn-light btn-sm" onClick={() => navigate("/admin/products")} >
            ← Back
          </button>
        </div>

        <div className="card-body">

          {/* Upload Section */}
          <div className="row mb-4 border-bottom border-1 pb-2">
            <div className="col-md-9">
              <input
                type="file"
                className="form-control"
                onChange={(e) => setSelectedFile(e.target.files[0])}
              />
            </div>
            <div className="col-md-3">
              <button
                className="btn btn-primary w-100"
                onClick={handleUpload}
                disabled={loading}
              >
                {loading ? "Uploading..." : "Upload Image"}
              </button>
            </div>
          </div>

          {/* Image List */}
          <div className="row">
            {images.length === 0 && (
              <p className="text-muted">No images found.</p>
            )}

            {images.map((img) => (
              <div className="col-md-3 mb-4" key={img.productImageId}>
                <div className="card h-100 shadow-sm">
                  <img
                    src={`${image_base_url}${img.imageUrl}`}
                    alt="Product"
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />

                  <div className="card-body text-center">

                    {img.isMain && (
                      <span className="badge bg-success mb-2">
                        Main Image
                      </span>
                    )}

                    <div className="d-grid gap-2">
                      {!img.isMain && (
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() =>
                            handleSetMain(img.imageId)
                          }
                        >
                          Set as Main
                        </button>
                      )}

                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() =>
                          handleDelete(img.imageId)
                        }
                      >
                        Delete
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProductImageManager;